/**
 * @fileoverview カードコンポーネントの汎用的な行レイアウトコンポーネント
 */
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { cardCommonProps } from '@/components/_parials/contentsCard'
import ContentsCard from '@/components/contents/ContentsCard.vue'
import SolutionContentsCard from '@/components/solutions/SolutionContentsCard.vue'

export default defineComponent({
  name: 'LayoutContentsCardsRows',

  components: {
    ContentsCard,
    SolutionContentsCard,
  },

  props: {
    ...cardCommonProps,

    /**
     * コンテンツ情報の配列
     */
    items: {
      type: Array as PropType<ContentItem[]>,
      required: true,
    },

    horizontal: {
      type: Object as PropType<{ pc: boolean, sp: boolean }>,
      default: () => ({
        pc: true,
        sp: true,
      }),
    },

    hasSolutionLink: {
      type: Boolean,
      default: true,
    },
  },
})
</script>

<template>
  <div
    v-if="items.length"
    class="o-list__contentsCard">
    <ul class="o-list__contentsCard--items">
      <li
        v-for="(item) in items"
        :key="item.id"
        class="o-list__contentsCard--item">
        <!--
          item に solution（製品）情報を持ってる場合は資料データのため、
          製品用のコンテンツカードをレンダリング
        -->
        <template v-if="item.solution">
          <SolutionContentsCard
            :item="item"
            :has-hero="hasHero"
            :highlight-word="highlightWord"
            :size="size"
            :horizontal="horizontal"
            :has-solution-link="hasSolutionLink"
            :heading-options="headingOptions"
            :image-options="imageOptions" />
        </template>
        <template v-else>
          <ContentsCard
            :item="item"
            :has-hero="hasHero"
            :highlight-word="highlightWord"
            :size="size"
            :horizontal="horizontal"
            :heading-options="headingOptions"
            :image-options="imageOptions" />
        </template>
      </li>
    </ul>
  <!-- /.o-list__contentsCard --></div>
</template>

<style lang="sass" scoped>
.o-list__contentsCard
  margin-top: 1em

  &:first-child
    margin-top: 0

  & &--item
    margin-top: 1.5em

    &:first-child
      margin-top: 0
</style>
